import isArray from "lodash/isArray";
import PropTypes from "prop-types";
import React from "react";
import Icon from "../Icon";

import AddAudienceHeader from "./AddAudienceHeader";
import AudienceSegmentQuotaEditor from "./AudienceSegmentQuotaEditor";
import ContinuousAudienceSegmentSelector from "./ContinuousAudienceSegmentSelector";
import DiscreteAudienceSegmentSelector from "./DiscreteAudienceSegmentSelector";
import IconButton from "./IconButton";

import { audienceProps } from "./audienceProps";
import { className, styles } from "./audienceStyles";

export default class EditAudienceCard extends React.PureComponent {
    static propTypes = {
        ...audienceProps,
        isReadOnly: PropTypes.bool.isRequired,
        quotasOpen: PropTypes.bool.isRequired,
        onCloseEditQuotas: PropTypes.func.isRequired,
        onOpenEditQuotas: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired,
        onSegmentChange: PropTypes.func.isRequired,
        onSegmentQuotaChange: PropTypes.func.isRequired
    };

    segmentSelectionComponent() {
        switch (this.props.type) {
            case "continuous":
                return ContinuousAudienceSegmentSelector;
            case "discrete":
            default:
                return DiscreteAudienceSegmentSelector;
        }
    }

    render() {
        const icons = isArray(this.props.icon)
            ? this.props.icon
            : [this.props.icon];

        const selectedSegments = this.props.segments.filter(
            seg => seg.isSelected
        );
        const canEditQuotas = selectedSegments.length > 0;
        const total = selectedSegments.reduce(
            (tot, seg) => tot + (seg.percentage || 0),
            0
        );
        const isValidTotal = total === 100;

        const SegmentSelector = this.segmentSelectionComponent();

        const enabled = !this.props.isLoading && !this.props.isReadOnly;
        const onRemove = enabled && this.props.onRemove;

        return (
            <div className={styles.audienceCard}>
                <AddAudienceHeader iconNames={icons} title={this.props.title}>
                    <div className={styles.audienceActions}>
                        {!this.props.isReadOnly && (
                            <button
                                type="button"
                                {...className("actionButton", "remove")}
                                onClick={onRemove}
                            >
                                <Icon icon={["far", "trash-alt"]} />
                            </button>
                        )}
                    </div>
                </AddAudienceHeader>
                <div className={styles.body}>
                    <div className={styles.leftSide}>
                        <SegmentSelector
                            isReadOnly={!enabled}
                            marks={this.props.marks}
                            segments={this.props.segments}
                            onChange={this.props.onSegmentChange}
                        />
                    </div>
                    <div className={styles.rightSide}>
                        {!this.props.quotasOpen && (
                            <IconButton
                                icon="chart-pie"
                                label={
                                    this.props.isReadOnly
                                        ? "View Quotas"
                                        : "Edit Quotas"
                                }
                                disabled={!canEditQuotas}
                                onClick={this.props.onOpenEditQuotas}
                            />
                        )}
                        {!this.props.quotasOpen &&
                            !isValidTotal && (
                                <span {...className("total", "invalid")}>
                                    Total: {total}%
                                </span>
                            )}
                        {this.props.quotasOpen && (
                            <AudienceSegmentQuotaEditor
                                isReadOnly={!enabled}
                                segments={this.props.segments}
                                onClose={this.props.onCloseEditQuotas}
                                onSegmentQuotaChange={
                                    this.props.onSegmentQuotaChange
                                }
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/EditAudienceCard.js